var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23617_7020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4913 8.02026C22.5234 8.25152 22.4511 8.48278 22.2826 8.64227L15.5566 15.3169C15.2516 15.5801 14.786 15.5402 14.5292 15.2292C14.2964 14.9581 14.2964 14.5593 14.5292 14.2882L20.8459 8.00431L14.5292 1.72839C14.2403 1.44131 14.2403 0.986767 14.5292 0.699686C14.8182 0.412605 15.2757 0.412605 15.5646 0.699686L22.2906 7.3823C22.4511 7.55774 22.5314 7.789 22.4913 8.02026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.30263 7.23828H20.5657C21.0071 7.23828 21.3683 7.59713 21.3683 8.03573C21.3683 8.47433 21.0071 8.83318 20.5657 8.83318H1.30263C0.861182 8.83318 0.5 8.47433 0.5 8.03573C0.5 7.59713 0.861182 7.23828 1.30263 7.23828Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23617_7020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 15,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.605f3848.svg";
export { ForwardRef as ReactComponent };